import { SurveyQuestionID, SurveyResponseID, UserFeedbackRequest } from '@forto-dev/notification-center-models'

export type SurveyQuestionResponse = {
  id: string
  responses: {
    id: string
    comment?: string
  }[]
}

const isSurveyQuestionID = (id: string): id is SurveyQuestionID => {
  return Object.values(SurveyQuestionID).includes(id as SurveyQuestionID)
}
const isSurveyResponseID = (id: string): id is SurveyResponseID => {
  return Object.values(SurveyResponseID).includes(id as SurveyResponseID)
}
/**
 * This function exists because the exported `Survey` type uses strings instead of enums, even though it should be fully typesafe.
 * This can be removed once the `Survey` type is updated to use enums.
 */
export const toUserFeedbackRequest = (questionResponse: SurveyQuestionResponse): UserFeedbackRequest => {
  if (!isSurveyQuestionID(questionResponse.id)) {
    throw new Error('Invalid SurveyQuestionID')
  }
  return {
    answeredQuestions: [
      {
        id: questionResponse.id,
        responses: questionResponse.responses.map((response) => {
          if (!isSurveyResponseID(response.id)) {
            throw new Error('Invalid SurveyResponseID')
          }
          return {
            id: response.id,
            comment: response.comment,
          }
        }),
      },
    ],
  }
}
